import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router";

const BackLink = ({
    to = "/account/signin",
    children = "Back",
    className = "mb-3 text-start",
    style = {},
}) => {
    const nav = useNavigate();
    return (
        <div className={className}>
            <Button
                variant="link"
                style={{
                    padding: 0,
                    color: "#0d6efd",
                    textDecoration: "none",
                    fontWeight: 500,
                    ...style,
                }}
                onClick={() => nav(to)}
            >
                <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ marginRight: "6px" }}
                />
                {children}
            </Button>
        </div>
    );
};

export default BackLink;
